<template>
    <div>
        <ModalBase v-show="visible" :modal-type="state">
            <template v-if="state==='error'" #header>
                <SadSmileySVG class="inline"></SadSmileySVG>
                {{ $t('dialog.invitation.register.title.lastNameNotFound') }}
            </template>
            <template v-else-if="state==='success'" #header>
                <HappySmileySVG class="inline"></HappySmileySVG>
                {{ $t('dialog.invitation.register.title.success', { fullName: fullName }) }}
            </template>
            <template v-else-if="state ==='invitationAlreayUsed'" #header>
                {{ $t('dialog.invitation.register.title.invitationAlreadyUsed') }}
            </template>
            <template v-else-if="state ==='invitationNotExisting'" #header>
                {{ $t('dialog.invitation.register.title.invitationNotExisting') }}
            </template>
            <template v-else #header>
                {{ $t('dialog.invitation.register.title') }}
            </template>

            <template #body>
                <div class="text-center">
                    <div v-if="state === 'initial'">{{ $t('dialog.invitation.register.subtitle') }}</div>
                    <div v-else-if="state === 'error'">{{ $t('dialog.invitation.register.subtitle.lastNameNotFound')}}
                    </div>
                    <div v-else-if="state === 'success'">{{ $t('dialog.invitation.register.subtitle.success')}}</div>
                    <div v-else-if="state === 'invitationNotExisting'">{{
                        $t('dialog.invitation.register.subtitle.invitationNotExisting') }}
                    </div>
                    <div v-else-if="state === 'invitationAlreayUsed'">{{
                        $t('dialog.invitation.register.subtitle.invitationAlreadyUsed') }}
                    </div>
                </div>
                <div class="flex flex-col" v-if="state === 'invitationAlreayUsed'">
                    <div class="text-center mt-4">
                        <p class="underline">{{ $t('dialog.invitation.register.invitationAlreadyUsed.redirect') }}</p>
                        <div class="mt-4">
                            <button @click="$router.push({ name: 'signin' }).catch(()=>{})"
                                    class="bg-blue-500 font-bold text-white px-4 py-1">
                                {{ $t('dialog.invitation.register.invitationAlreadyUsed.signin') }}
                            </button>
                        </div>
                    </div>
                </div>
                <div class="flex flex-col" v-else-if="state === 'initial' || state === 'error'">
                    <input v-model="last_name.value"
                           @keyup.enter="check"
                           @input="checkLastName"
                           class="border border-gray-500 rounded py-2 pl-2 mt-3"
                           :class="{ 'border-red-600' : last_name.error }"
                           :placeholder="$t('dialog.invitation.register.lastName.placeholder')">
                    <label class="text-red-600"
                           v-if="last_name.error !== ''">
                        {{ last_name.error }}
                    </label>
                </div>
                <div class="flex flex-col" v-else-if="state === 'success'">
                    <input v-model="username.value"
                           class="border border-gray-500 rounded py-2 pl-2 mt-3"
                           :class="{ 'border-red-600' : username.error }"
                           :placeholder="$t('dialog.invitation.register.userName.placeholder')">
                    <label class="text-red-600"
                           v-if="username.error !== ''">
                        {{ username.error }}
                    </label>

                    <input v-model="password.value"
                           type="password"
                           @keyup.enter="register"
                           class="border border-gray-500 rounded py-2 pl-2 mt-3"
                           :class="{ 'border-red-600' : password.error }"
                           :placeholder="$t('dialog.invitation.register.password.placeholder')">
                    <label class="text-red-600"
                           v-if="password.error !== ''">
                        {{ password.error }}
                    </label>

                    <input v-model="repeatPassword.value"
                           type="password"
                           @keyup.enter="register"
                           @input="checkPassword"
                           class="border border-gray-500 rounded py-2 pl-2 mt-3"
                           :class="{ 'border-red-600' : repeatPassword.error }"
                           :placeholder="$t('dialog.invitation.register.repeatPassword.placeholder')">
                    <label class="text-red-600"
                           v-if="repeatPassword.error !== ''">
                        {{ repeatPassword.error }}
                    </label>

                    <div>
                        <input type="checkbox"
                               class="mr-2"
                               id="privacyNotice"
                               v-model="privacyNotice.value">
                        <label class="text-gray-600 inline cursor-pointer"
                               @click="privacyNoticeShow = !privacyNoticeShow">
                            {{ $t('dialog.invitation.register.privacyNotice') }}
                        </label>
                    </div>
                    <label class="text-red-600"
                           v-if="privacyNotice.error !== ''">
                        {{ privacyNotice.error }}
                    </label>

                </div>
            </template>
            <template #footer-without-padding>
                <div class="w-full flex justify-between px-4 pb-4">
                    <div></div>
                    <div>
                        <button v-if="state === 'initial' || state === 'error'" @click="check"
                                class="bg-blue-500 font-bold text-white px-4 py-1">
                            {{ $t('dialog.invitation.register.check') }}
                        </button>
                        <button v-else-if="state === 'success'" @click="register"
                                class="bg-blue-500 font-bold text-white px-4 py-1">
                            {{ $t('dialog.invitation.register.register') }}
                        </button>
                    </div>
                </div>
                <div v-if="state === 'error'" class="bg-gray-200 px-10 text-center pt-4">
                    <p>{{ $t('dialog.invitation.register.lastNameNotFoundMessage') }}</p>
                    <!--<p class="font-bold">32454</p>-->

                    <Contact class="py-4" name="" :phone="getPhoneNumber"></Contact>
                </div>

                <div v-if="state === 'invitationNotExisting'" class="bg-gray-200 px-10 text-center pt-4">
                    {{ $t('dialog.invitation.register.invitationNotExisting.contact')}}
                    <Contact class="py-4" name="" :phone="getPhoneNumber"></Contact>
                </div>
            </template>
        </ModalBase>
        <ModalBase v-show="privacyNoticeShow" modal-type="initial" @close="privacyNoticeShow = !privacyNoticeShow">
            <template #header>
                {{ $t('component.privacyNotice.header') }}
            </template>
            <template #body>
                <div class="mt-4 overflow-x-auto border p-2 shadow-inner text-sm" style="height: 300px;">
                    <div>
                        <div class="font-bold">{{ $t('component.privacyNotice.part.1.header') }}</div>
                        <div>
                            <p>{{ $t('component.privacyNotice.part.1.text1') }}</p>
                            <p class="mt-4">{{ $t('component.privacyNotice.part.1.text2') }}</p>
                        </div>
                    </div>
                    <div class="mt-4">
                        <div class="font-bold">{{ $t('component.privacyNotice.part.2.header' )}}</div>
                        <div>
                            <p>{{ $t('component.privacyNotice.part.2.text1' )}} </p>
                            <p class="mt-4">{{ $t('component.privacyNotice.part.2.text2' )}}</p>
                            <p class="mt-4">{{ $t('component.privacyNotice.part.2.text3' )}}</p>
                            <p class="mt-4">
                                {{ $t('component.privacyNotice.part.2.text4' )}}
                            </p>
                        </div>
                    </div>

                    <div class="mt-4">
                        <div class="font-bold">{{ $t('component.privacyNotice.part.3.header') }}</div>
                        <div>
                            <p>
                                {{ $t('component.privacyNotice.part.3.text1') }}
                            </p>
                            <p class="mt-4">{{ $t('component.privacyNotice.part.3.text2') }}</p>
                            <p class="mt-4">{{ $t('component.privacyNotice.part.3.text3') }}</p>
                            <p v-html="$t('component.privacyNotice.part.3.text4')">
                            </p>
                        </div>
                    </div>

                    <div class="mt-4">
                        <div class="font-bold">{{ $t('component.privacyNotice.part.4.header') }}</div>
                        <div>
                            <p>{{ $t('component.privacyNotice.part.4.text1') }}</p>
                            <p class="mt-4">{{ $t('component.privacyNotice.part.4.text2') }}</p>
                            <p class="mt-4">{{ $t('component.privacyNotice.part.4.text3') }}</p>
                            <p class="mt-4" v-html="$t('component.privacyNotice.part.4.text4')">
                            </p>
                            <p class="mt-4">{{ $t('component.privacyNotice.part.4.text5') }}</p>
                            <p class="mt-4" v-html="$t('component.privacyNotice.part.4.text6')">
                            </p>
                        </div>
                    </div>
                </div>
            </template>
            <template #footer>
                <div class="flex">
                    <button @click="acceptPrivacyNotice"
                            class="border rounded py-2 px-4 mt-4 cursor-pointer shadow w-24">
                        {{ $t('dialog.privacyNotice.close') }}
                    </button>
                </div>
            </template>
        </ModalBase>
    </div>
</template>

<script>
    import ModalBase from "@/components/shared/ModalBase";
    import {UserService, ValidationError, InvitationNotExisting, InvitationAlreadyUsed} from "@/services/user.service";
    import SadSmileySVG from "@/components/shared/svgs/SadSmileySVG";
    import HappySmileySVG from "@/components/shared/svgs/HappySmileySVG";
    import Contact from "@/components/Contact";
    import {mapGetters} from "vuex";

    export default {
        name: "RegisterModal",
        components: {HappySmileySVG, SadSmileySVG, ModalBase, Contact},
        data() {
            return {
                visible: true,
                state: 'initial',

                uid: this.$route.params.uid,
                fullName: '',
                last_name: {
                    value: '',
                    error: ''
                },
                username: {
                    value: '',
                    error: ''
                },
                password: {
                    value: '',
                    error: ''
                },
                repeatPassword: {
                    value: '',
                    error: ''
                },
                invalidInvitation: {
                    error: ''
                },
                privacyNotice: {
                    value: false,
                    error: ''
                },

                recruiter_name: '',
                recruiter_phone: '',

                privacyNoticeShow: false
            }
        },
        computed: {
            ...mapGetters('dlGroupConfig', [
                'getPhoneNumber',
            ]),
        },
        watch: {
            'privacyNotice.value': function (value) {
                if (value) {
                    this.privacyNotice.error = "";

                }
            }
        },
        async created() {
            await this.validateInvitation(this.$route.params.uid);
        },
        methods: {
            async validateInvitation(uid) {
                try {
                    var data = await UserService.validateInvitation(uid);
                    if (data) {
                        this.$i18n.locale = data.language;
                    }
                } catch (e) {
                    if (e instanceof InvitationAlreadyUsed) {
                        this.state = 'invitationAlreayUsed';
                        this.redirectToLogin();
                    } else if (e instanceof InvitationNotExisting) {
                        this.state = 'invitationNotExisting';
                    }
                }
            },

            async redirectToLogin() {
                setTimeout(() => {
                    this.$router.push({name: 'signin'}).catch(() => {
                    });
                }, 5000);
            },

            checkLastName() {
                if (this.last_name.value.length > 0) {
                    this.last_name.error = '';
                }
            },

            async check() {
                try {
                    if (this.last_name.value.length === 0) {
                        this.last_name.error = this.$t('dialog.invitation.register.subtitle')
                        return;
                    }

                    const result = await UserService.verifyInvitationName(this.uid, this.last_name.value);
                    const firstName = result.first_name;
                    const lastName = result.last_name;

                    this.recruiter_name = result.recruiter.name;
                    this.recruiter_phone = result.recruiter.phone;

                    this.fullName = `${firstName} ${lastName}`;

                    this.state = 'success';
                    this.last_name.error = '';
                } catch (e) {
                    if (e instanceof ValidationError) {
                        this.state = 'error';
                        this.last_name.error = this.$t('dialog.invitation.register.lastName.notFound');

                        if (e.fields.length > 0) {
                            if (e.fields[0].error_code === 1) {
                                this.$store.dispatch('auth/logout').then(() => {
                                    this.$router.push({name: 'signin'}).catch(() => {
                                    });
                                });
                            }
                        }
                    } else {
                        this.$store.dispatch('auth/logout').then(() => {
                            this.$router.push({name: 'signin'}).catch(() => {
                            });
                        });
                    }
                }
            },

            checkPassword() {
                if (this.password.value !== this.repeatPassword.value) {
                    this.repeatPassword.error = this.$t('dialog.invitation.register.repeatPassword.error');
                } else {
                    this.repeatPassword.error = ''
                }
            },

            async register() {
                if (!this.privacyNotice.value) {
                    this.privacyNotice.error = this.$t('dialog.invitation.register.privacyNotice.error');
                    return;
                }

                this.resetFields();

                if (this.password.value !== this.repeatPassword.value) {
                    this.repeatPassword.error = this.$t('dialog.invitation.register.repeatPassword.error');
                    return;
                }

                try {
                    await UserService.register(this.uid, this.last_name.value, this.password.value, this.username.value).then(() => {
                        this.$ga.event('Register', 'success', 'Successful Registration', 1);
                        this.$store.dispatch('auth/logout').then(() => {
                            this.$store.dispatch('auth/login', {
                                username: this.username.value,
                                password: this.password.value
                            });
                            this.$store.dispatch('auth/filter');
                            this.$store.dispatch('mission/filter');
                        });
                    });
                } catch (e) {
                    let self = this;
                    if (e instanceof ValidationError) {
                        for (var field in e.fields) {
                            if (field === 'last_name') {
                                self.last_name.error = e.fields[field].join(', ');
                            } else if (field === 'username') {
                                self.username.error = e.fields[field].join(', ');
                            } else if (field === 'password') {
                                self.password.error = e.fields[field].join(', ');
                            }
                        }
                    } else if (e instanceof InvitationNotExisting) {
                        this.state = 'invitationNotExisting';
                    }
                }
            },
            resetFields() {
                this.last_name.error = '';
                this.username.error = '';
                this.password.error = '';
                this.invalidInvitation.error = '';
            },
            acceptPrivacyNotice() {
                this.privacyNoticeShow = false;
                this.privacyNotice.value = true;
            }
        }
    }
</script>

<style scoped>

</style>